<div>
    {{ data[header.field] | number:'':'en-IN' }}
</div>